import styled from 'styled-components';

import money_coin from 'assets/icons/money_coin.svg';

import closed_eye from 'assets/icons/closed_eye.svg';

export const Container = styled.article`
  position: relative;

  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 15px;

  width: 100%;
  max-width: 410px;
  min-height: 95px;

  padding: 5px;

  border-radius: 60px;
  box-shadow: 0 3px 10px rgb(0 0 0 /16%);

  .tag__cash-coin {
    width: 80px;
    height: 80px;

    border-radius: 40px;

    background: no-repeat cover;
    background-image: url(${money_coin});
  }

  .tag__revenue {
    display: flex;
    flex-direction: column;
    gap: 10px;

    color: #8e92a7;
    font-size: 1.1rem;
  }

  .tag__revenue__value {
    color: var(--blue12);
    font-size: 1.5rem;
    font-weight: bold;
  }

  .tag__revenue__view-button,
  .tag__revenue__view-button--closed{
    margin: 0 20px 0 auto;

    background-color: transparent;
    border: 0;
    cursor: pointer;
  }


  @media (max-width: 310px) {
    .tag__cash-coin {
      display: none;
    }
    padding: 15px;
  }
`;
